import { attractionFromHost } from "@/lib/attractions/registry";
import type { AttractionId } from "@/lib/attractions/types";

export type CustomerSiteAnalyticsContext = {
  attractionId: AttractionId;
  attractionBrand: string;
  attractionHost: string;
};

function normalizedHost(rawHost: string): string {
  return rawHost.trim().toLowerCase().replace(/:\d+$/, "");
}

export function isCustomerSiteBrowserAnalyticsPath(pathname: string): boolean {
  return !(
    pathname === "/app" ||
    pathname.startsWith("/app/") ||
    pathname === "/login" ||
    pathname.startsWith("/login/") ||
    pathname === "/alert" ||
    pathname.startsWith("/alert/") ||
    pathname.startsWith("/api/") ||
    pathname.startsWith("/sites/") ||
    pathname.startsWith("/_next/")
  );
}

export function customerSiteAnalyticsContext(
  rawHost: string,
  pathname: string,
): CustomerSiteAnalyticsContext | null {
  if (!isCustomerSiteBrowserAnalyticsPath(pathname)) return null;
  const attraction = attractionFromHost(rawHost);
  if (!attraction) return null;
  return {
    attractionId: attraction.id,
    attractionBrand: attraction.brandName,
    attractionHost: normalizedHost(rawHost),
  };
}
